import { render, staticRenderFns } from "./StatsFinanceGeneral.vue?vue&type=template&id=1209c563&scoped=true"
import script from "./StatsFinanceGeneral.vue?vue&type=script&lang=js"
export * from "./StatsFinanceGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1209c563",
  null
  
)

export default component.exports